var ProductJs = function( item, product ) {
    var optionsMap = {};
    var optionsMapAll = {};

  var init = function() {
        if(!item.hasClass('initialized')) {
          initVariantStatus();
          initializeVariantSelector();
          initGallery();
          item.addClass('initialized');
        }
  };

  var initVariantStatus = function() {
    $.each(product.variants, function(key, variant){
            //AVAILABLE
            if(variant.available) {
              variant.status = 'available';
            } else {
              //SOLDOUT
              variant.status = 'soldout';
            }
    })
  };

  var initializeVariantSelector = function() {
        var variantSelectorId = "product-select-"+product.id;
    var selectCallback = onVariantSelected();
    
    if($(".product-pot-wrap").length == 0 || item.find('.thumbs-swatches-wrap .thumb').length == 0){
      new Shopify.OptionSelectors(variantSelectorId, { product: product, onVariantSelected: selectCallback });
    }
    
    if(product.options.length > 1) {
      if(product.variants.length > 1) {
        linkOptionSelectors(product);
      }

      // Add label if only one product option and it isn't 'Title'.
      if(product.options.length == 1 && product.options[0] != 'Title') {
        item.find('.selector-wrapper:eq(0)').prepend('<label>'+product.options[0]+'</label>');
      }

      item.find('.selector-wrapper label').append(':');
    } else {
      if(product.variants.length > 1) {
        item.find('.select-variant').change(function(){
          var variantSelected = false;
          $.each(product.variants, function(key, variant){
            if(variant.id==item.find('.select-variant').val()) {
              variantSelected = variant;
              return;
            }
          });
          selectCallback(variantSelected, null);
        });
      }
    }

    
    if($('.product-gift-card').length == 0){
      item.find('.swatch :radio').change(function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
      });
    }
    
    if(item.closest('.product-pot-wrap').length == 0){
      item.find('.price-details').hide();
    }

    
    $(document).on("click", ".product-pots .thumbs-swatches-wrap a", function(event){
      event.preventDefault();
      //console.log(event);
       
      $('#thumbs .current-pot img').css('opacity','0');
      
      $(".product-pots .thumbs-swatches-wrap a").removeClass('active');

      if($(".product-pots .thumbs-swatches-wrap-pots a.group-" + $(this).data('group')).length > 0){
        $(".product-pots .thumbs-swatches-wrap-pots a.group-" + $(this).data('group')).first().addClass('active');
      }
      
      if($(this).hasClass('thumb-var') || $("#product-wrap").hasClass("product-non-plant")){
        $(this).addClass('active')
      }
      
      $(".product-pots .pots-groups .pot-group").hide();
      if($(".product-pots .pots-groups .pot-group#pot-group-" + $(this).data('group')).length){
        $(".product-pots .pot-groups-section").addClass('animation').css('opacity','1').css('top','0').css('height', 'auto');
        $(".product-pots .pots-groups .pot-group#pot-group-" + $(this).data('group')).show();
      }else{
        $(".product-pots .pot-groups-section").removeClass('animation').css('opacity','0').css('top','-10px').css('height', '0');
      }
      
      //Selecting first variant
      if(!$(this).hasClass('thumb-var')){
        $(".product-pots .pots-groups .pot-group#pot-group-" + $(this).data('group')).find('a').not('.sold-out').first().addClass('active')
      }

      $(".selected-pot .pot-title").html(
        '<span class="pot-label">' + $(this).data('pot-category') + '</span>' +
        '<span class="pot-sep"> | </span>' +
        '<span class="pot-value">' + $(this).data('pot-value') + '</span>'
      );
      // Change the image
      //item.find('#thumbs-pots-plants a.gallery[data-pot-handle="' + $(this).data('pot-handle') + '"]').trigger("click");
      //changeImage($(this).data('pot-handle'));
      
      // Filter thumbs
      //item.find('#thumbs').slick("slickSetOption", 'speed', 100, true);
      if(item.find('#thumbs').hasClass('slick-initialized')){
        item.find('#thumbs').slick('slickUnfilter');
        setTimeout(function(){ 
          if($('#thumbs .current-pot').length){
            item.find('#thumbs').slick('slickGoTo', $('#thumbs .current-pot').data('slick-index'));
          }else{
            item.find('#thumbs').slick('slickGoTo', 0); 
          }
        }, 501);
      }
      //item.find('#thumbs').slick("slickSetOption", 'speed', 1000, true);
      
// Clear previous active classes
      item.find('#thumbs div').removeClass('current-pot');

      // --- HYBRID STEP 1: Primary Image via Variant ID ---
      var selectedVariantId = $(this).data('pot-id') || $(this).data('pot-variant-id');
      
      if (selectedVariantId) {
        // Trigger the click to swap the main large image at the top
        item.find('#thumbs a[variant-id="' + selectedVariantId + '"]').trigger("click");
        
        // Add the class to make sure it shows up in the mobile thumbnail carousel
        item.find('#thumbs a[variant-id="' + selectedVariantId + '"]').parent().addClass('current-pot');
      }

      // --- HYBRID STEP 2: Gallery Images via File Name / Handle ---
      var potHandleVar = $(this).data('pot-handle-var');
      if (potHandleVar) {
        item.find('#thumbs a.gallery[data-pot-handle="' + potHandleVar + '"]').parent().addClass('current-pot');
      }
      
      // Execute the Slick Filter
      if (isMobile.any) {
        var potHandleColor = $(this).data('pot-handle-color');
        if (potHandleColor) {
          item.find('#thumbs a.gallery[data-pot-handle="' + potHandleColor + '"]').parent().addClass('current-pot');
        }

        if(item.find('#thumbs').hasClass('slick-initialized')) {
          item.find('#thumbs').slick('slickFilter','.item_gallery, .current-pot');
        }
        $('#thumbs img').css('opacity','1');
      } else {
        if(item.find('#thumbs').hasClass('slick-initialized')){
          item.find('#thumbs').slick('slickFilter','.item_gallery');
        }
      }
      
      // Update the pot & potting fee information
      var potId = $(this).data('pot-id');
      var pottingFeeId = $(this).data('potting-fee-id');
      item.find('#pot-id').val(potId);
      if($(".product-pot-wrap").length > 0){
        item.find('#product-'+product.id+'-variant').val(potId);
      }
      item.find('#potting-fee-id').val(pottingFeeId);
      item.find('.pot-details-img img').hide()
      item.find('.pot-details-img img.pot-img-' + $(this).data('pot-handle')).show();
      item.find('.pot-details-text .pot-text').hide();
      item.find('.pot-details-text .pot-text.pot-text-' + $(this).data('pot-handle')).show();
      
      if($("#product-wrap").hasClass("product-non-plant")){
        if (product.options.length > 1) {
          var selectedColor = $(this).data('color');
          var selectedSize = item.find('.size-button.active').data('size');
          var matchedVariant = null;

          if (selectedSize) {
            matchedVariant = getVariantByOptions(selectedColor, selectedSize);
          }

          if (!matchedVariant) {
            matchedVariant = getVariantById(potId);
          }

          if (matchedVariant) {
            item.find('#product-' + product.id + '-variant').val(matchedVariant.id);
            selectCallback(matchedVariant, null);
          }
        } else {
          item.find('.select-variant').val(potId).change();
        }
      }
      
      //Saucer
      var saucerId = $(this).attr('data-saucer-id');
      item.find('#saucer-id').val(saucerId);
      
      // Set combo ID
      var selectedVariant = item.find("input[name=id]").val();
      if(saucerId){
        item.find('#product-combo-id').val(selectedVariant + "-" + potId + "-" + saucerId);
      }else{
        item.find('#product-combo-id').val(selectedVariant + "-" + potId);
      }
      

      // Show prices
      if (item.find('input.pot-selector').is(':checked')) {
        var pottingFeePrice = $(this).data('potting-fee-price');
      } else { 
        var pottingFeePrice = 0;
      };
      if (item.find('input.saucer-selector').is(':checked')) {
        var saucerPrice = parseInt($(this).attr('data-saucer-price')) || 0;
      } else { 
        var saucerPrice = 0;
      };
      
      var potPrice = $(this).data('pot-price');
      var potComparePrice = $(this).data('pot-compare-price');
      var finalPrice = product.price + potPrice + pottingFeePrice;
      if(saucerPrice > 0){
        finalPrice = finalPrice + saucerPrice;
      }
      //console.log('finalprice:', finalPrice);
      if(pottingFeePrice > 0){
        item.find('.price-details .potting-fee-price .number').html(Shopify.formatMoney(pottingFeePrice, formatMoney).replace('.00', '').replace(' ', ''));
        item.find('.price-details .potting-fee-price').css('opacity','1').css('top','0');
      }else{
        item.find('.price-details .potting-fee-price').css('opacity','0').css('top','-10px');
        setTimeout(function(){
        item.find('.price-details .potting-fee-price .number').html('0');
        }, 500);
      }
      
    if(saucerId){
        var visualSaucerSwatch = $(this).attr('data-saucer-swatch');
        var visualSaucerUrl = $(this).attr('data-saucer-url');
        
        item.find('.saucercheckbox .saucer-swatch').css('background-image', 'url(' + visualSaucerSwatch + ')');
        item.find('.saucercheckbox a').attr("href", visualSaucerUrl);
        
        var visualSaucerPrice = $(this).data('saucerPrice') || $(this).data('saucer-price') || 0;
        
        item.find('.saucercheckbox .saucer-price').html(Shopify.formatMoney(visualSaucerPrice, formatMoney).replace('.00', '').replace(' ', ''));
        item.find('.saucercheckbox').css('height', 'auto').css('opacity','1').css('top','0');
      } else {
        item.find('.saucercheckbox').css('height', '0').css('opacity','0').css('top','-10px');
        item.find('.saucercheckbox .saucer-price').html('0');
      }

	// console.log(potPrice);
      if(potPrice > 0){
        item.find('.price-details .pot-price .number').html(Shopify.formatMoney(potPrice+saucerPrice, formatMoney).replace('.00', '').replace(' ', ''));
        item.find('.price-details .pot-price').show();
        item.find('.price-details .plant-price').show();
        item.find('.price-details').show();
        item.find('.potting-fee-tooltip').show();
        console.log(potPrice);
        console.log(potComparePrice);
        if(potComparePrice == ''){
          item.find('.price-details .pot-price').find("del").hide();
        }
        else{
          item.find('.price-details .pot-price').find("del").html(Shopify.formatMoney(potComparePrice, formatMoney).replace('.00', '').replace(' ', ''));
          item.find('.price-details .pot-price').find("del").show();
        }
      }else{
        item.find('.price-details .pot-price').hide();
        item.find('.price-details .plant-price').hide();
        item.find('.price-details').hide();
        item.find('.price-details .pot-price .number').html('0');
        item.find('.potting-fee-tooltip').hide();
      }

      item.find('.final-price .number').html(Shopify.formatMoney(finalPrice, formatMoney).replace('.00', '').replace(' ', ''));
      
      
      item.find('.buttons-wrapper .add-button, .buttons-wrapper .sold-out-button, .soldout-product-message').hide(); //Grid
      item.find('.content-available, .content-soldout').hide(); //Product page
      if($(this).hasClass('sold-out')){
        item.find('#product-info .quantity').hide();
        item.find('.buttons-wrapper .sold-out-button').show(); //Grid
        item.find('.soldout-product-message').show(); //Grid
        item.find('.content-soldout').show(); //Product page
      }else if(product.available){
        item.find('#product-info .quantity').show();
        item.find('.buttons-wrapper .add-button').show(); //Grid
        item.find('.content-available').show(); //Product page  
      }else{
        item.find('.content-soldout').show();
      }
      
      
    });

item.on('click', '.size-button', function(e) {
  e.preventDefault();

  item.find('.size-button').removeClass('active');
  $(this).addClass('active');

  var selectedSize = $(this).data('size');

  updateThumbsForSelectedSize(selectedSize);

  var $activeThumb = item.find('.product-pots .thumbs-swatches-wrap a.active').first();

  if (!$activeThumb.length) {
    $activeThumb = item.find('.product-pots .thumbs-swatches-wrap a').first();
    $activeThumb.addClass('active');
  }

  var selectedColor = $activeThumb.data('color');
  var matchedVariant = getVariantByOptions(selectedColor, selectedSize);

  if (matchedVariant) {
    item.find('#product-' + product.id + '-variant').val(matchedVariant.id);
    
    // SAFE SKU CHECK FOR ACTIVE THUMB
    var skuPart = (matchedVariant.sku && matchedVariant.sku !== '') ? '-' + matchedVariant.sku.toLowerCase() : '';
    var newHandleVar = product.handle + skuPart;

    // UPDATE DATA CACHE FOR THE ACTIVE THUMB (camelCase)
    $activeThumb.data('potId', matchedVariant.id);
    $activeThumb.attr('data-pot-id', matchedVariant.id);
    
    $activeThumb.data('potHandleVar', newHandleVar);
    $activeThumb.attr('data-pot-handle-var', newHandleVar);

    // Swap the main product image
    selectCallback(matchedVariant, null);

    // Force UI update so the price recalculates
    $activeThumb.trigger('click');
  }
});



    if(product.variants.length==1) {
      if($(".product-pot-wrap").length == 0){
        selectCallback(product.variants[0], null);
      }
    } else {
      
      if($('.product-gift-card').length == 0){
        setDefaultVariant(getFirstAvailableVariant());
      }
      
    }
  };

    setTimeout(function() {
      // 1. Click the first size
      var $firstSize = item.find('.size-button').first();
      if ($firstSize.length) {
       $firstSize.trigger('click');
      }
      
      // 2. Evaluate initial size availability based on default color
      var $activeThumb = item.find('.product-pots .thumbs-swatches-wrap a.active').first();
      if (!$activeThumb.length) {
        $activeThumb = item.find('.product-pots .thumbs-swatches-wrap a').first();
      }
      var initColor = $activeThumb.attr('data-color') || $activeThumb.data('color');
      updateSizeButtonsForSelectedColor(initColor);
      
    }, 100);

  var getFirstAvailableVariant = function() {
    for( var i = 0; i < product.variants.length; i++){ 
      if(product.variants[i].available)
        return product.variants[i];
    } 
  };

  var getVariantBySku = function(sku) {
    for(var i = 0; i < product.variants.length; i++){ 
      if(product.variants[i].sku == sku)
        return product.variants[i];
    } 
  };

  var getVariantById = function(id) {
    for(var i = 0; i < product.variants.length; i++){ 
      if(product.variants[i].id == id)
        return product.variants[i];
    } 
  };

    var getVariantByOptions = function(option1, option2) {
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].option1 == option1 && product.variants[i].option2 == option2) {
        return product.variants[i];
      }
    }
    return null;
  };

    var getVariantByColor = function(color) {
  for (var i = 0; i < product.variants.length; i++) {
    if (product.variants[i].option1 == color) {
      return product.variants[i];
    }
  }
  return null;
};

var getSaucerVariant = function(color, selectedSize) {
    var saucerMapping = {
      "30": "saucer-10-ol",
      "34": "saucer-10-ol",
      "40": "saucer-14-ol",
      "46": "saucer-14-ol"
    };

    var sizeMatch = (selectedSize || '').match(/\d+/);
    if (!sizeMatch) return null;
    
    var sizeNumber = sizeMatch;
    var saucerHandle = saucerMapping[sizeNumber];
    
    if (!saucerHandle || !window.saucerDictionary || !window.saucerDictionary[saucerHandle]) {
      return null; 
    }

    var saucerProduct = window.saucerDictionary[saucerHandle];
    if (!saucerProduct || !saucerProduct.variants) return null;

    var cleanColor = (color || '').toString().toLowerCase().trim();

    for (var i = 0; i < saucerProduct.variants.length; i++) {
      var opt1 = (saucerProduct.variants[i].option1 || '').toString().toLowerCase().trim();
      var opt2 = (saucerProduct.variants[i].option2 || '').toString().toLowerCase().trim();
      
      if (opt1 === cleanColor || opt2 === cleanColor) {
        saucerProduct.variants[i].product_url = '/products/' + saucerProduct.handle; 
        saucerProduct.variants[i].product_image = saucerProduct.featured_image; 
        return saucerProduct.variants[i];
      }
    }

    return null;
  };

var updateThumbsForSelectedSize = function(selectedSize) {
  item.find('.product-pots .thumbs-swatches-wrap a').each(function() {
    var $thumb = $(this);
    var color = $thumb.data('color');
    
    // NEW: Track if the exact size/color combo actually exists in Shopify
    var exactMatch = true; 
    var matchedVariant = getVariantByOptions(color, selectedSize);

    if (!matchedVariant) {
      exactMatch = false; // The combo does not exist!
      matchedVariant = getVariantByColor(color); // Fallback just to keep the thumbnail image visible
    }

    if (!matchedVariant) return;

    var skuPart = (matchedVariant.sku && matchedVariant.sku !== '') ? '-' + matchedVariant.sku.toLowerCase() : '';
    var handleVar = product.handle + skuPart;

    // 1. UPDATE JQUERY'S DATA CACHE
    $thumb.data('potId', matchedVariant.id);
    $thumb.data('potVariantId', matchedVariant.id);
    $thumb.data('potPrice', matchedVariant.price);
    $thumb.data('potComparePrice', matchedVariant.compare_at_price || '');
    $thumb.data('potHandleVar', handleVar);

    // 2. UPDATE THE HTML ATTRIBUTES
    $thumb.attr('data-pot-id', matchedVariant.id);
    $thumb.attr('data-pot-variant-id', matchedVariant.id);
    $thumb.attr('data-pot-price', matchedVariant.price);
    $thumb.attr('data-pot-compare-price', matchedVariant.compare_at_price || '');
    $thumb.attr('data-pot-handle-var', handleVar);

    // 3. SAUCER LOGIC
    var matchedSaucer = getSaucerVariant(color, selectedSize);
    
    if (matchedSaucer) {
      var newSwatch = '';
      if (matchedSaucer.featured_image && matchedSaucer.featured_image.src) {
        newSwatch = Shopify.Image.getSizedImageUrl(matchedSaucer.featured_image.src, '80x');
      } else if (matchedSaucer.product_image) {
        newSwatch = Shopify.Image.getSizedImageUrl(matchedSaucer.product_image, '80x');
      }
      
      var newUrl = (matchedSaucer.product_url || '') + '?variant=' + matchedSaucer.id;

      $thumb.attr('data-saucer-id', matchedSaucer.id);
      $thumb.attr('data-saucer-price', matchedSaucer.price);
      $thumb.attr('data-saucer-url', newUrl);
      $thumb.attr('data-saucer-swatch', newSwatch);
      
      $thumb.data('saucerId', matchedSaucer.id);
      $thumb.data('saucerPrice', matchedSaucer.price);
    } else {
      $thumb.removeAttr('data-saucer-id data-saucer-price data-saucer-url data-saucer-swatch');
      $thumb.removeData('saucerId saucerPrice saucer-url saucer-swatch');
    }

    // 4. UPDATE AVAILABILITY (Now with exactMatch protection)
    if (exactMatch && matchedVariant.available) {
      $thumb.removeClass('sold-out').css({
        'pointer-events': 'auto', 
        'cursor': 'pointer'
      });
    } else {
      $thumb.addClass('sold-out').css({
        'pointer-events': 'none', 
        'cursor': 'not-allowed'
      });
    }


  });
};

var updateSizeButtonsForSelectedColor = function(selectedColor) {
  if (!selectedColor) return;

  item.find('.size-button').each(function() {
    var $btn = $(this);
    var size = $btn.data('size');
    
    // Cross-reference the active color with this button's size
    var matchedVariant = getVariantByOptions(selectedColor, size);

    // If the variant exists AND has stock
    if (matchedVariant && matchedVariant.available) {
      $btn.removeClass('is-disabled').css({
        'opacity': '1',
        'pointer-events': 'auto', // Allows clicking
        'cursor': 'pointer'
      });
    } else {
      // If the variant is out of stock (or doesn't exist)
      $btn.addClass('is-disabled').css({
        'opacity': '0.4',         // Greys it out visually
        'pointer-events': 'none', // Completely disables clicking/flipping
        'cursor': 'not-allowed'
      });
    }
  });
};

  var setDefaultVariant = function(variant){
    if(variant) {
      $('.single-option-selector').each(function(){
        var selector = this;
        var option = $(selector).data('option');
        $(selector).find('option').each(function(){
          if(this.value == variant[option]){
            $(selector).val(this.value).trigger('change');
            return;
          }
        });
      });
    }
  };
  
  var onVariantSelected = function() {
    return function(variant, selector) {
      if(variant && variant.id) {

        
        if($('.product-gift-card').length == 0){
          //Swatches code
          var form = item.find('form');
          for(var i=0,length=variant.options.length; i<length; i++) {
            var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
            if(radioButton.size()) {
              radioButton.get(0).checked = true;
            }
          }
        }
        

        
        
        //Update the price
        item.find('form .price .deal span').html(Shopify.formatMoney(variant.price, formatMoney).replace('.00', '').replace(' ', ''));
        if(variant.compare_at_price != null){
          item.find('form .price .retail span').html(Shopify.formatMoney(variant.compare_at_price, formatMoney).replace('.00', '').replace(' ', ''));
          var percent = Math.round( (((variant.compare_at_price - variant.price) * 100 ) / variant.compare_at_price) );
          item.find('.off-percent strong').html(percent+'%');
        }
        
        if(item.find('.thumbs-swatches-wrap .thumb').length == 0){
          item.find('.price-details .pot-price .number').html(Shopify.formatMoney(variant.price, formatMoney).replace('.00', '').replace(' ', ''));
          item.find('.price-details .pot-price').show();
        }

        //Update the fetured image
        var downloadingImage = new Image();
        if(variant.featured_image) {
          $('#active-wrapper img').css('opacity','0');
          var tini = new Date().getTime();
          downloadingImage.onload = downloadingImage.onerror = function(){
            var tdelta = Math.max(1, 100 - (new Date().getTime() - tini));
            setTimeout(function() {
              //Image in grid
              item.find('.image img').attr('src', variant.featured_image.src);

              //Image in product page
              item.find('#active-wrapper img').attr('src', variant.featured_image.src);
              item.find('#active-wrapper a').attr('href', variant.featured_image.src);
              $('#active-wrapper img').css('opacity','1');
            }, tdelta);
          }; 
          downloadingImage.src = variant.featured_image.src;
        }

        //Update the variant value to add to cart
        item.find('#product-'+product.id+'-variant').val(variant.id);

        item.find('.soldout-product-message').show();
        item.find('.sold-out-button .without-extended-offer').show();
        
      } else {
        item.find('#product-'+product.id+'-variant').val("");
      }
      
      updateButtons(variant);

      $(item).trigger("variantChange", [variant]);
      
    }
  };
  
  var updateButtons = function(variant) {
    var status;
    if(product.available) {
      status = variant ? variant.status : 'available';
    } else {
      status = 'soldout';
    }

    item.find('.buttons-wrapper .add-button, .buttons-wrapper .sold-out-button, .soldout-product-message').hide(); //Grid
    item.find('.content-available, .content-soldout').hide(); //Product page
    switch(status) {
      case "available":
        item.find('.buttons-wrapper .add-button').show(); //Grid
        item.find('.content-available').show(); //Product page
        break;
      case "soldout":
        item.find('.buttons-wrapper .sold-out-button').show(); //Grid
              item.find('.soldout-product-message').show(); //Grid
        item.find('.content-soldout').show(); //Product page
        break;
    }
  };
  
    var initGallery = function(){
        var switchImage = function(newImageSrc, mainImageDomEl) {
          //setTimeout(function(){ 
            $(mainImageDomEl).attr('src', newImageSrc);
            if(item.find('#product-gallery').hasClass('zoom-in') && !isMobile.any) { 
              $(mainImageDomEl).parent().trigger('zoom.destroy').zoom( { url: newImageSrc.replace('_large', '') } ); 
            }
            $(mainImageDomEl).parents('a').attr('href', newImageSrc);
          //}, 150);
        };
        var onImagesLoaded = function(images, callback){
            var imagesLoaded = 0;
            images.each(function(){
              var img = new Image();
              img.onload = function() {
                imagesLoaded++;
                if(imagesLoaded==images.length) {
                  callback();
                }
              };
              img.src = $(this).attr('src');
            });
        };

      //Initialize thumbs on main product page
      var changeImage = function(potHandle){
        var newImg = $('#thumbs-pots-plants a.gallery[data-pot-handle-var="' + potHandle + '"]');
        if (newImg.attr('href')) {
          $('#active-wrapper img').css('opacity','0');
          var tini = new Date().getTime();
          var variantId = newImg.attr('variant-id');
          var downloadingImage = new Image();
          downloadingImage.onload = downloadingImage.onerror = function(){
            var tdelta = Math.max(1, 100 - (new Date().getTime() - tini));
            setTimeout(function() {
              switchImage(newImg.attr('href'), item.find('#active-wrapper img')[0]);
              $('#active-wrapper img').css('opacity','1');
            }, tdelta);
          }; 
          downloadingImage.src = newImg.attr('href');
        }
		

        item.find('.pot-potting-info').show();
        if(variantId && variantId!='') {
          var variant = $.grep(product.variants, function(obj){ return obj.id==variantId; });
          if(variant[0] && variant[0].available) {
            if(product.options.length <= 1) {
              item.find('.select-variant').val(variantId).change();
            } else {
              var variantTitle = item.find('.select-variant option[value='+variantId+']').text();
              $.each(variantTitle.split(' / '), function(key, val){
                item.find('.single-option-selector:eq('+key+')').val(val).change();
              });
            }
          }
        }
      }
      $(document).on("click", ".product-pots .thumbs-swatches-wrap a", function(event){
        // changeImage($(this).data('pot-handle-var'))  <-- Just add the two slashes here to disable it
        
        // Retrieve the color of the thumbnail just clicked and update sizes
        var clickedColor = $(this).attr('data-color') || $(this).data('color');
        updateSizeButtonsForSelectedColor(clickedColor);
      });

        
      
      
        item.find('#thumbs-pots-plants a').on('click', function(e) {
          e.preventDefault();
          if ($(this).attr('href')) {
            $('#active-wrapper img').css('opacity','0');
            var tini = new Date().getTime();

            var variantId = $(this).attr('variant-id');
            var downloadingImage = new Image();
            downloadingImage.onload = downloadingImage.onerror = function(){
              var tdelta = Math.max(1, 100 - (new Date().getTime() - tini));
              setTimeout(function() {
                switchImage($(this).attr('href'), item.find('#active-wrapper img')[0]);
                $('#active-wrapper img').css('opacity','1');
              }, tdelta);
            }; 
            downloadingImage.src = $(this).attr('href');
          }
            
          
          item.find('.pot-potting-info').show();
            if(variantId && variantId!='') {
                var variant = $.grep(product.variants, function(obj){ return obj.id==variantId; });
                if(variant[0] && variant[0].available) {
                  if(product.options.length <= 1) {
                        item.find('.select-variant').val(variantId).change();
                    } else {
                        var variantTitle = item.find('.select-variant option[value='+variantId+']').text();
                        $.each(variantTitle.split(' / '), function(key, val){
                            item.find('.single-option-selector:eq('+key+')').val(val).change();
                        });
                    }
                }
            }
        });
      
      var reclick = function() {
        item.find('input.pot-selector, input.saucer-selector').change(function(){
          item.find('.product-pots a.thumb.active').trigger('click');
          item.find('.final-price .number').css('opacity','0');
          setTimeout(function(){ 
            item.find('.final-price .number').css('top','-10px');
            item.find('.final-price .number').addClass('animation');
          }, 200);
          setTimeout(function(){ 
            item.find('.final-price .number').css('opacity','1').css('top','0px');
          }, 500);
          item.find('.final-price .number').removeClass('animation');
        });
      }
      reclick();
      
        item.find('#thumbs.switch a').on('click', function(e) {
          e.preventDefault();
          switchImage($(this).attr('href'), item.find('#active-wrapper img')[0]);
          reclick();
        });
      
        onImagesLoaded(item.find('#thumbs img'), function(){
          item.find('#thumbs').slick({
            autoplay: false,
            speed: 500,
            slidesToShow: 5,
            slidesToScroll: 1,
            
            vertical: true,
            verticalSwiping: true,	
            prevArrow: '<i class="lnr lnr-chevron-up up-arrow animation"></i>',
            nextArrow: '<i class="lnr lnr-chevron-down down-arrow animation"></i>',
            
            infinite: false,
            waitForAnimate: true,
            responsive: [
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  vertical: false,
                  verticalSwiping: false,
                  dots: true,
                  arrows: true,
                  prevArrow: '<i class="lnr lnr-chevron-left left-arrow animation"></i>',
                  nextArrow: '<i class="lnr lnr-chevron-right right-arrow animation"></i>'
                }
              }
            ]
          });
          if(isMobile.any){
            item.find('#thumbs').slick('slickFilter','.item_gallery, .current-pot');
          }else{
            item.find('#thumbs').slick('slickFilter','.item_gallery');
          }
        });

        //Initialize zoom on main product image
        if(item.find('#product-gallery').hasClass('zoom-in') && !isMobile.any) {
            var mainProductImage = $('#active-wrapper img');
            if (mainProductImage.size()) {
                var zoomedSrc = item.find('#active-wrapper img').attr('src').replace('_large', '');
                item.find('#active-wrapper img')
                    .wrap('<span style="display:block"></span>')
                    .css('display', 'block')
                    .parent()
                    .zoom( { url: zoomedSrc } );
            }
        }
      
        //Initialize photoswipe on main product image
        if($('#thumbs a[rel="photoswipe"]').length > 0) {
          item.find('#thumbs a[rel="photoswipe"]').photoSwipe();
          item.find('#thumbs-pots-plants a.gallery').photoSwipe();
          item.find('#active-wrapper a.productImage').click(function(){
            var found = false;
            productImage = $(this);
            item.find('#thumbs a[rel="photoswipe"]').each(function(){
              if($(this).attr('href').substr($(this).attr('href').indexOf('//')).replace(/_1024x1024/g, '') == 
                 productImage.attr('href').substr(productImage.attr('href').indexOf('//')).replace(/_1024x1024/g, '')){
                $(this).click();
                found = true;
                return false;
              }
            });
            
            if(!found){
              item.find('#thumbs-pots-plants a.gallery').each(function(){
                if($(this).attr('href').substr($(this).attr('href').indexOf('//')).replace(/_1024x1024/g, '') == 
                   productImage.attr('href').substr(productImage.attr('href').indexOf('//')).replace(/_1024x1024/g, '')){
                  $(this).click();
                  found = true;
                  //console.log($(this).attr('href'));
                  return false;
                }
              });
            }
            
            return false;
          });
        } else {
          if($('#active-wrapper a.productImage').length > 0) {
            item.find('#active-wrapper a.productImage').photoSwipe();
          }
        }
    }
    
    // (c) Copyright 2014 Caroline Schnapp. All Rights Reserved. Contact: mllegeorgesand@gmail.com
    // See http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options

    var updateOptionsInSelector = function(selectorIndex) {
      switch (selectorIndex) {
        case 0:
          var key = 'root';
          var selector = item.find('.single-option-selector:eq(0)');
          break;
        case 1:
          var key = item.find('.single-option-selector:eq(0)').val();
          var selector = item.find('.single-option-selector:eq(1)');
          break;
        case 2:
          var key = item.find('.single-option-selector:eq(0)').val();  
          key += ' / ' + item.find('.single-option-selector:eq(1)').val();
          var selector = item.find('.single-option-selector:eq(2)');
      }

      var initialValue = selector.val();
      selector.empty();
      var options = optionsMapAll[key];
      if(options) {
        for (var i=0; i<options.length; i++) {
          var option = options[i];
          var newOption = jQuery('<option></option>').val(option).html(option);
          selector.append(newOption);
        }
      }

      var availableOptions = optionsMap[key];
      var existingOptions = optionsMapAll[key];
      item.find('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
        //Checks if the variant exists
        if(jQuery.inArray($(this).attr('data-value'), existingOptions)!==-1) {
          //Checks if the variant is available
          if(jQuery.inArray($(this).attr('data-value'), availableOptions)!==-1) {
            $(this).removeClass('soldout').find(':radio').removeAttr('checked');
          } else {
            $(this).addClass('soldout').find(':radio').removeAttr('checked');
          }
          $(this).show();
        } else {
          $(this).hide();
        }
      });

      if(jQuery.inArray(initialValue, availableOptions) !== -1) {
        selector.val(initialValue);
      }
      selector.trigger('change');
    };

    var linkOptionSelectors = function(product) {
      // Building our mapping object.
      for (var i=0; i<product.variants.length; i++) {
        var variant = product.variants[i];

        // Gathering values for the 1st drop-down.
        optionsMapAll['root'] = optionsMapAll['root'] || [];
        optionsMapAll['root'].push(variant.option1);
        optionsMapAll['root'] = Shopify.uniq(optionsMapAll['root']);
        // Gathering values for the 2nd drop-down.
        if (product.options.length > 1) {
          var key = variant.option1;
          optionsMapAll[key] = optionsMapAll[key] || [];
          optionsMapAll[key].push(variant.option2);
          optionsMapAll[key] = Shopify.uniq(optionsMapAll[key]);
        }
        // Gathering values for the 3rd drop-down.
        if (product.options.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          optionsMapAll[key] = optionsMapAll[key] || [];
          optionsMapAll[key].push(variant.option3);
          optionsMapAll[key] = Shopify.uniq(optionsMapAll[key]);
        }

        if (variant.available) {
          // Gathering values for the 1st drop-down.
          optionsMap['root'] = optionsMap['root'] || [];
          optionsMap['root'].push(variant.option1);
          optionsMap['root'] = Shopify.uniq(optionsMap['root']);
          // Gathering values for the 2nd drop-down.
          if (product.options.length > 1) {
            var key = variant.option1;
            optionsMap[key] = optionsMap[key] || [];
            optionsMap[key].push(variant.option2);
            optionsMap[key] = Shopify.uniq(optionsMap[key]);
          }
          // Gathering values for the 3rd drop-down.
          if (product.options.length === 3) {
            var key = variant.option1 + ' / ' + variant.option2;
            optionsMap[key] = optionsMap[key] || [];
            optionsMap[key].push(variant.option3);
            optionsMap[key] = Shopify.uniq(optionsMap[key]);
          }
        }
      }

      // Update options right away.
      updateOptionsInSelector(0);
      if (product.options.length > 1) updateOptionsInSelector(1);
      if (product.options.length === 3) updateOptionsInSelector(2);

      // When there is an update in the first dropdown.
      item.find(".single-option-selector:eq(0)").change(function() {
        updateOptionsInSelector(1);
        if (product.options.length === 3) updateOptionsInSelector(2);
        return true;
      });

      // When there is an update in the second dropdown.
      item.find(".single-option-selector:eq(1)").change(function() {
        if (product.options.length === 3) updateOptionsInSelector(2);
        return true;
      });

    };

  return init();
};

//Shopify option_selection.js
function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}"undefined"==typeof window.Shopify&&(window.Shopify={}),Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},Shopify.map=function(t,e){for(var o=[],i=0;i<t.length;i++)o.push(e(t[i],i));return o},Shopify.arrayIncludes=function(t,e){for(var o=0;o<t.length;o++)if(t[o]==e)return!0;return!1},Shopify.uniq=function(t){for(var e=[],o=0;o<t.length;o++)Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return e},Shopify.isDefined=function(t){return void 0!==t},Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},Shopify.extend=function(t,e){function o(){}o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t,t.baseConstructor=e,t.superClass=e.prototype},Shopify.locationSearch=function(){return window.location.search},Shopify.locationHash=function(){return window.location.hash},Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},Shopify.newState=function(t,e){return(Shopify.urlParam(t)?Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===Shopify.locationSearch()?"?"+t+"="+e:Shopify.locationSearch()+"&"+t+"="+e)+Shopify.locationHash()},Shopify.setParam=function(t,e){Shopify.replaceState(Shopify.newState(t,e))},Shopify.Product=function(t){Shopify.isDefined(t)&&this.update(t)},Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},Shopify.Product.prototype.optionNames=function(){return"Array"==Shopify.getClass(this.options)?this.options:[]},Shopify.Product.prototype.optionValues=function(t){if(!Shopify.isDefined(this.variants))return null;var e=Shopify.map(this.variants,function(e){var o="option"+(t+1);return e[o]==undefined?null:e[o]});return null==e[0]?null:Shopify.uniq(e)},Shopify.Product.prototype.getVariant=function(t){var e=null;return t.length!=this.options.length?e:(Shopify.each(this.variants,function(o){for(var i=!0,r=0;r<t.length;r++){o["option"+(r+1)]!=t[r]&&(i=!1)}if(1==i)return void(e=o)}),e)},Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var o=this.variants[e];if(t==o.id)return o}return null},Shopify.money_format="$",Shopify.formatMoney=function(t,e){function o(t,e){return void 0===t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split(".");return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i)+(n[1]?r+n[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_with_space_separator":r=i(t,2," ",",");break;case"amount_with_period_and_space_separator":r=i(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",");break;case"amount_no_decimals_with_space_separator":r=i(t,0," ");break;case"amount_with_apostrophe_separator":r=i(t,2,"'",".")}return a.replace(n,r)},Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new Shopify.Product(e.product),this.onVariantSelected=Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new Shopify.OptionSelectors.HistoryState(this)),!0},Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0};if(!this.selectVariantFromDropdown(t)){var e=this;setTimeout(function(){e.selectVariantFromParams(t)||e.fireOnChangeForFirstDropdown.call(e,t)})}},Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){this.selectVariantFromParams(t)||this.selectVariantFromDropdown(t)},Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),o=e.parentNode;Shopify.each(this.buildSelectors(),function(t){o.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var o=e.value;return this.selectVariant(o,t)},Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=Shopify.urlParam("variant");return this.selectVariant(e,t)},Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var o=this.product.getVariantById(t);if(null==o)return!1;for(var i=0;i<this.selectors.length;i++){var r=this.selectors[i].element,n=r.getAttribute("data-option"),a=o[n];null!=a&&this.optionExistInSelect(r,a)&&(r.value=a)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var o=0;o<t.options.length;o++)if(t.options[o].value==e)return!0},Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var o=document.getElementById(t);Shopify.each(this.buildSelectors(),function(t){o.appendChild(t)})},Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var o=this.selectorDivClass,i=this.product.optionNames();return Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",o),i.length>1){var r=document.createElement("label");r.htmlFor=t.element.id,r.innerHTML=t.name,e.appendChild(r)}return e.appendChild(t.element),e})},Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o=this.selectors[e].element.value;t.push(o)}return t},Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var o=this.selectedValues(),i=this.product.getVariant(o);i?(this.variantIdField.disabled=!1,this.variantIdField.value=i.id):this.variantIdField.disabled=!0,this.onVariantSelected(i,this,e),null!=this.historyState&&this.historyState.onVariantChange(i,this,e)},Shopify.OptionSelectorsFromDOM=function(t,e){var o=e.optionNames||[],i=e.priceFieldExists||!0,r=e.delimiter||"/",n=this.createProductFromSelector(t,o,i,r);e.product=n,Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},Shopify.extend(Shopify.OptionSelectorsFromDOM,Shopify.OptionSelectors),Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,e,o,i){if(!Shopify.isDefined(o))var o=!0;if(!Shopify.isDefined(i))var i="/";var r=document.getElementById(t),n=r.childNodes,a=(r.parentNode,e.length),s=[];Shopify.each(n,function(t){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var r=t.innerHTML.split(new RegExp("\\s*\\"+i+"\\s*"));0==e.length&&(a=r.length-(o?1:0));var n=r.slice(0,a),p=o?r[a]:"",l=(t.getAttribute("value"),{available:!t.disabled,id:parseFloat(t.value),price:p,option1:n[0],option2:n[1],option3:n[2]});s.push(l)}});var p={variants:s};if(0==e.length){p.options=[];for(var l=0;l<a;l++)p.options[l]="option "+(l+1)}else p.options=e;return p},Shopify.SingleOptionSelector=function(t,e,o,i){this.multiSelector=t,this.values=i,this.index=e,this.name=o,this.element=document.createElement("select");for(var r=0;r<i.length;r++){var n=document.createElement("option");n.value=i[r],n.innerHTML=i[r],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id=t.domIdPrefix+"-option-"+e,this.element.onchange=function(o,i){i=i||{},t.updateSelectors(e,i)},!0},Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);return null!==e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!=o){var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)}return null},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||Shopify.setParam("variant",t.id))},Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState};